// This file can be replaced during build by using the `fileReplacements` array.
// `ng build --prod` replaces `environment.ts` with `environment.prod.ts`.
// The list of file replacements can be found in `angular.json`.

export const environment = {
  production: true,
  loginServiceUrl: 'https://bl-test.internal.sparbankensyd.se/api',
  authServiceUrl: 'https://bl-test.internal.sparbankensyd.se/service',
  domain: 'bl-test.internal.sparbankensyd.se',
  blancoDomain: 'www-test.lana.sparbankensyd.se'
}
